import { render, staticRenderFns } from "./UploadedFileStatus.vue?vue&type=template&id=f80db77c&scoped=true"
import script from "./UploadedFileStatus.vue?vue&type=script&lang=js"
export * from "./UploadedFileStatus.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileStatus.vue?vue&type=style&index=0&id=f80db77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80db77c",
  null
  
)

export default component.exports